function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { parse, stringify } from 'qs';
import { useLocation, isBrowser } from '@ies/ace';
import { history } from '@@/core/history';
import { parsePathParams, transformUrlWithRegion } from '@/utils';
import { Locale2RegionMap } from '@/constants/i18n';
const supportRegions = Object.keys(Object.keys(Locale2RegionMap).reduce((regions, cur) => {
  regions[Locale2RegionMap[cur]] = 1;
  return regions;
}, {}));

const Anchor = _a => {
  var _b;

  var {
    children,
    href,
    target,
    onClick,
    appendTrackParams,
    hash
  } = _a,
      props = __rest(_a, ["children", "href", "target", "onClick", "appendTrackParams", "hash"]);

  const location = useLocation();
  const query = parse((_b = location.search.slice(1)) !== null && _b !== void 0 ? _b : '');
  const params = parsePathParams(location.pathname);

  if ((params === null || params === void 0 ? void 0 : params.page) && (params === null || params === void 0 ? void 0 : params.region)) {
    const genHref = path => {
      const basename = !isBrowser() ? `/${params.page}/${params.region}` : '';

      if (!path) {
        return path;
      }

      if (/^(https?:)\/\//i.test(path)) {
        return path;
      }

      let pathname = '';
      let addLang = false;

      if (path.indexOf('./') === 0) {
        pathname = basename + path.slice(1);
        addLang = true;
      } else if (path.indexOf('/') === 0) {
        const pathParams = parsePathParams(path);
        pathname = !supportRegions.includes((pathParams === null || pathParams === void 0 ? void 0 : pathParams.region) || '') ? transformUrlWithRegion(path, params.region) : path;
        addLang = true;
      } else {
        pathname = path;
      }

      if (addLang && query.lang) {
        const pathSplit = pathname.split('?');
        const pQuery = parse(pathSplit[1] || '');
        pQuery.lang = query.lang;
        const search = stringify(pQuery);
        pathname = pathSplit[0] + (search ? `?${search}` : '');
      }

      return !isBrowser() ? history.createHref({
        pathname
      }) : pathname;
    };

    href = genHref(href);
  }

  const handleClick = evt => {
    var _a;

    onClick === null || onClick === void 0 ? void 0 : onClick(evt);

    if (evt.defaultPrevented) {
      return;
    }

    evt.preventDefault();

    if (href) {
      const url = (_a = appendTrackParams === null || appendTrackParams === void 0 ? void 0 : appendTrackParams(href)) !== null && _a !== void 0 ? _a : href;
      window.open(url + (hash ? `#${hash}` : ''), target || '_self');
    }
  };

  return /*#__PURE__*/React.createElement("a", _extends({}, props, {
    style: {
      cursor: 'pointer'
    },
    onClick: handleClick
  }), children);
};

export default Anchor;